import { cn } from '@ds';
import { PropsWithChildren } from 'react';

type SectionRowProps = PropsWithChildren<{
  label: string;
  truncate?: boolean;
  fontNormal?: boolean;
  centerItems?: boolean;
}>;

// TODO use SectionRow in General.tsx in CP and remove passing <SectionRow/> component to EtaSections
const SectionRow = ({ label, children, truncate = true, fontNormal = false, centerItems = true }: SectionRowProps) => {
  return (
    <div className={cn('grid grid-cols-2 gap-4', { 'items-center': centerItems })}>
      <span className={cn('text-base-20 text-m-r', { truncate })}>{label}</span>
      <div className={cn('text-m-m', truncate ? 'truncate' : 'wrap-break-word', { 'font-normal': fontNormal })}>
        {children || '-'}
      </div>
    </div>
  );
};

export default SectionRow;
